'use client';

import { useRef } from 'react';
import { useScroll, useTransform } from 'framer-motion';
import {
  DEFAULT_WITNESS_CARD_MOTION_PROFILE,
  type WitnessCardMotionProfile,
} from './cwitnesscardConstants';
import type { CwitnesscardProps } from './Cwitnesscard.types';

export function useCwitnesscardMotion({
  scrollContainerRef,
}: Pick<CwitnesscardProps, 'scrollContainerRef'>) {
  const cardRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: cardRef,
    container: scrollContainerRef,
    offset: ['start end', 'end start'],
  });
  const motionProfile: WitnessCardMotionProfile =
    DEFAULT_WITNESS_CARD_MOTION_PROFILE;
  const opacity = useTransform(
    scrollYProgress,
    motionProfile.progressStops,
    motionProfile.opacity,
  );
  const scale = useTransform(
    scrollYProgress,
    motionProfile.progressStops,
    motionProfile.scale,
  );
  const brightness = useTransform(
    scrollYProgress,
    motionProfile.progressStops,
    motionProfile.brightness,
  );
  const brightnessFilter = useTransform(
    brightness,
    (value) => `brightness(${value})`,
  );
  const imageWrapperY = useTransform(scrollYProgress, [0, 1], [-50, 80]);
  const imageWrapperOpacity = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    [0.8, 1, 1],
  );

  return {
    brightnessFilter,
    cardRef,
    imageWrapperOpacity,
    imageWrapperY,
    opacity,
    scale,
  };
}
